import login from './login'
import nav from './_nav.json'
import activity from './activity'
import dict from './dict.json'
import demo from './demo.json'

export default {
  site_title: 'JDYun.com',
  title: 'JDYun Activities System',
  system_demo: 'System Demo',
 
  confirm: 'Confirm',
  cancel: 'Cancel',
  show: 'Show',
  hide: 'Hide',
  open: 'Open',
  close: 'Close',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  add: 'Add',
  search: 'Search',
  query: 'Query',
  reset: 'Reset',
  submit: 'Submit',
  upload: 'Upload',
  download: 'Download',
  export: 'Export',
  import: 'Import',

  started: 'Started',
  ended: 'Ended',
  next: 'Next',
  prev: 'Prev',
  publish: 'Publish',
  input: 'Please Input {text}',
  select: 'Please Select {text}',
  total: 'Total {total}',
  price: '{price} RMB',
  required: '{text} is required',
  selected: 'Selected {total} {text}',
  create: 'Create',
  free: 'Free',
  charge: 'Charge',
  default: 'Default',
  custom: 'Custom',
  max: 'Max',
  min: 'Min',
  percent: 'Percent',
  online: 'Online',
  offline: 'Offline',
  name: 'Name',
  remark: 'Remark',
  tips: 'Tips',
  header: {
    logout: 'Log out',
    binding: 'Bind Account',
    mobile: 'Mobile Merchant Client',
    register: 'Mobile Client',
    tips: 'Activity {name}',
    qrcodeText: '{name} H5 QR code',
    qrcodeMiniText: '{name} applet code',
    qrcode: 'Click to download QR code',
    qrcodeMini: 'Click to download applet code'
  },
  home: {
    title: 'Welcome to Jindouyun activity Management Platform',
    sub_title: 'Publish the most complete and detailed activitys and conference activities here',
    desc: 'Start your activity hosting journey from activity management',
    create: 'Quickly create an activity'
  },
  user: {
    title: 'Account basic information',
    logo: 'Brand Logo',
    update: 'Update',
    name: 'Company or organization name',
    short_name: 'Brand in the upper left menu bar',
    enable: 'Turn on personalized login',
    web_tips: 'Personalized login URL',
    copy: 'Copy URL',
    login: 'Login page brand name',
    login_title: 'Login page system name'
  },
  login,
  activity,
  demo,
  ...nav,
  ...dict,
  // CODE_SUCCESS: 2000,
  2000: '操作请求成功',
  // CODE_ERROR: 5000,
  5000: '网络请求异常，请检查网络',
  // CODE_ERROR_PARAMS: 5001,
  5001: '请求参数错误',
  // URL注册失败
  // CODE_ERROR_URL_REG_FAILURE: 5002,
  5002: 'URL注册失败',
  // CODE_ERROR_NO_PARAM: 5003,
  5003: '参数错误',
  // CODE_ERROR_PERSSION_ERROR: 5004,
  5004: '权限错误',
  // JWT 验证错误
  // CODE_JWT_ERROR: 5100,
  5100: 'JWT 验证失败',
  // CODE_JWT_LOGIN_FAILURE: 5101,
  5101: '登录失败',
  // JWT Token 无效
  // CODE_JWT_TOKEN_INVALID: 5102,
  5102: 'JWT 无效',
  // CODE_JWT_NO_USER: 5103,
  5103: '用户不存在',
  //
  // CODE_PARAMS_TYPE_ERROR_SIZE = 5401
  5401: 'size 参数出错',
  //
  // CODE_PARAMS_TYPE_ERROR_PAGE = 5402
  5402: 'page 参数出错',
  //
  // CODE_PARAMS_TYPE_ERROR_QUERY = 5403
  5403: '查询关键字出错'
}



// WEBPACK FOOTER //
// ./src/langs/en/index.js